// @flow
import React, { Component } from 'react';
import type { Element } from 'react';
import { Grid, Row, Col } from 'Common/Grid';

import ErrorBox from 'Common/ErrorBox';

/**
 * <NotFound /> component.
 */
export class NotFound extends Component<*, *> {
  /**
   * Renders the Page Not Found.
   *
   * @return {JSX} - page not found markup.
   */
  render(): Element<*> {
    return (
      <Grid>
        <Row>
          <Col colXs={12} colSm={12} colMd={12} colLg={12}>
            <ErrorBox type={404} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/NotFound/index.js